'use client';

import { ContactsInner } from './ContactsInner';
import { ContactsRu } from './ContactsRu';

import { useFeatureFlags } from '@/shared/context';
import { useGetClientHost } from '@/shared/hooks';
import { Locale, TranslatedComponent } from '@/shared/types';
import { isRuDomain } from '@/shared/utils/getDomainInfo';

export const Contacts = ({
  locale,
  translations,
}: TranslatedComponent & {
  locale: Locale;
}) => {
  const { isFeatureEnabled } = useFeatureFlags();

  const clientHost = useGetClientHost();

  const isRuHost = isRuDomain(clientHost);

  // После релиза интеграции с манго - удалить флаг и условие
  if (!isFeatureEnabled('enableMaskedPhone')) {
    return (
      <ContactsInner
        clientHost={clientHost}
        translations={translations}
        locale={locale}
      />
    );
  }

  if (isRuHost) {
    return <ContactsRu translations={translations} />;
  }

  return (
    <ContactsInner
      clientHost={clientHost}
      translations={translations}
      locale={locale}
    />
  );
};
